import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from 'constants/vernacularConstants';
import { getStringFromId } from '../../../helpers/vernacular';
import { addressRegex, numericRegex } from '../../../constants/regex';
import { STATUS_CODE } from 'api/constants';

/**
 *
 * @description validateHouse is to validate house input field in the address form
 * @param address address value as string
 * @returns returns { error: string , hasError: boolean} in case any error exists
 */

export const validateHouse = (address: string) => {
  const fieldRequiredText = getStringFromId(
    VERNACULAR_STRING_IDS.THIS_FIELD_IS_REQUIRED,
    VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED,
  );

  let error = '';
  let hasError = false;

  if (typeof address !== 'string') {
    error = fieldRequiredText,
    hasError = true;

    return {
      error,
      hasError,
    };
  }

  address = address.trim();
  if (!address) {
    error = fieldRequiredText,
    hasError = true;
  }
  /* we are allowing only few special characters ' “ , . / @ # & - _ : ; ( ) *
    along with these special characters, all English characters (caps and small), and all numeric characters are included.
  */
  else if (!addressRegex.test(address)) {
    error = getStringFromId(
      VERNACULAR_STRING_IDS.SPECIAL_CHARS,
      VERNACULAR_DEFAULT_MESSAGES.SPECIAL_CHARS
    );
    hasError = true;
  }
  else if (address.length < 1) {
    error = getStringFromId(
      VERNACULAR_STRING_IDS.HOUSE_MIN_CHARS,
      VERNACULAR_DEFAULT_MESSAGES.HOUSE_MIN_CHARS
    );
    hasError = true;
  } else {
    error = '';
  }

  return {
    error,
    hasError,
  };
};

/**
 *
 * @description validateArea is to validate area input field in the address form
 * @param address address value as string
 * @returns returns { error: string , hasError: boolean} in case any error exists
 */

export const validateArea = (address: string) => {
  const fieldRequiredText = getStringFromId(
    VERNACULAR_STRING_IDS.THIS_FIELD_IS_REQUIRED,
    VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED
  );

  let error = '';
  let hasError = false;

  if (typeof address !== 'string') {
    error = fieldRequiredText,
    hasError = true;

    return {
      error,
      hasError,
    };
  }

  address = address.trim();
  address = address.replace(/(\r\n|\n|\r)/gm, '');
  if (!address) {
    error = fieldRequiredText,
    hasError = true;
  } else if (address.length < 5) {
    error = getStringFromId(
      VERNACULAR_STRING_IDS.AREA_MIN_CHARS,
      VERNACULAR_DEFAULT_MESSAGES.AREA_MIN_CHARS
    );
    hasError = true;
  }
  /* we are allowing only few special characters ' “ , . / @ # & - _ : ; ( ) *
    along with these special characters, all English characters (caps and small), and all numeric characters are included.
  */
  else if (!addressRegex.test(address)) {
    error = getStringFromId(
      VERNACULAR_STRING_IDS.SPECIAL_CHARS,
      VERNACULAR_DEFAULT_MESSAGES.SPECIAL_CHARS,
    );
    hasError = true;
  } else {
    error = '';
  }

  return {
    error,
    hasError,
  };
};

/**
 * fuction to show ADDRESS_NOT_SERVICEABILITY bottom sheet based on status code.
 */
export const showAddressNotServiceAbleBottomSheet = (code = "") => {
  if (
    code === STATUS_CODE.ADDRESS_NOT_SERVICEABILITY_BEAUTY ||
    code === STATUS_CODE.ADDRESS_NOT_SERVICEABILITY_FASHION
  ) {
    return true;
  }

  return false;
};


/**
 * function to get request params for serviceability
 * @param {IGetRequestParamsForServiceabilityParams} getRequestParamsForServiceabilityParams
 * @returns {any} requestParams
 */
export const getRequestParamsForServiceability = (
  getRequestParamsForServiceabilityParams: IGetRequestParamsForServiceabilityParams
) => {
  const {
    pincode,
    isInternational,
    countryToShip,
    deviceType,
    isBeautyPlatform,
  } = getRequestParamsForServiceabilityParams;
  let requestParams: any = {};
  if (isBeautyPlatform) {
    requestParams = new FormData();
    requestParams.append("pincode", pincode);
    requestParams.append("deviceType", deviceType);
    if (isInternational) {
      requestParams.append("countryCode", countryToShip);
    }
    return requestParams;
  }

  return { pincode, deviceType };
};
